/* eslint-disable @typescript-eslint/naming-convention */
// Reason: beberapa props ambil dari BE

import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import { ContactIcon } from '@/components/icons';
import { useModal } from '@/hooks/useModal';
import { UseShipping } from '@/modules/check-shipping-price/application/check-shipping-price';
import { IContact } from '@/modules/contact/model/contact';
import { useOrder } from '@/modules/order/application/order';
import { convertNumberToCurrency } from '@/utility/helper/common';
import {
  Button,
  Radio,
  RadioGroup,
  TextArea,
  Typography,
  useSnackbar,
} from '@rrexpress/core';
import { useForm } from '@refinedev/react-hook-form';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { ParcelForm } from './components/parcel-form';
import { ParcelTable } from './components/parcel-table';
import { SelectContactForm } from './components/select-contact-form';
import { isArray } from 'lodash';

export function OrderForm(props: {
  onSubmit: (data: IOrderCreatePayload) => void,
}) {
  const [packages, setPackages] = useState<Package[]>([]);
  const [selectedTypeContact, setSelectedTypeContact] = useState('select-contact');
  const [selectedTypeConsignee, setSelectedTypeConsignee] = useState('select-contact');
  const [currentOrderMethod, setCurrentOrderMethod] = useState('pickup');
  const [availableServices, setAvailableService] = useState<[]>([]);

  const userLoginData = JSON.parse(Cookies.get('user_login') as string);
  const { show } = useSnackbar();
  const { checkShippingPrice, loadingCreate: isLoading } = UseShipping();

  const modal = useModal();
  const form = useForm<any>({
    defaultValues: {
      order_date_time_utc: new Date().toISOString(),
      pickup_schedule_date_time_utc: new Date().toISOString(),
      order_method: 'pickup',
      shipper_pickup_longlat: '0,0',
    },
  });
  const {
    handleSubmit, watch, setValue, getValues, ...restUseFormInstance
  } = form;
  const { calculateParcelPrice } = useOrder();
  const {
    shipper_pickup_city_id = '',
    shipper_pickup_village_id = '',
    consignee_delivery_subdistrict_id = '',
    consignee_delivery_village_id = '',
    origin_id,
    destination_id,
    order_method,
  } = getValues() || {}; // key for triggering render

  const onAddPackage = (data: Package) => {
    setPackages((prev) => {
      const copy = prev.slice();
      copy.push(data);
      syncTotalParcel(copy);
      return copy;
    });
  };

  const onRemoveParcel = (index: number) => {
    setPackages((prev) => {
      const copy = prev.slice();
      copy.splice(index, 1);
      syncTotalParcel(copy);
      return copy;
    });
  };

  const onUpdateParcel = (record: any) => {
    // handleOpenModalPackageForm(record)
  };

  const onResetAddress = (type: 'shipper' | 'consignee') => {
    const addrPrefix = type === 'shipper' ? 'shipper_pickup' : 'consignee_delivery';
    const keys = {
      ContactId: `${type}_contact_id`,
      Email: `${type}_email`,
      Name: `${type}_name`,
      PhoneNumber: `${type}_phone_number`,
      Address: `${addrPrefix}_address`,
      CityId: `${addrPrefix}_city_id`,
      CityName: `${addrPrefix}_city_name`,
      CountryId: `${addrPrefix}_country_id`,
      CountryName: `${addrPrefix}_country_name`,
      LongLat: `${addrPrefix}_longlat`,
      ProvinceId: `${addrPrefix}_province_id`,
      ProvinceName: `${addrPrefix}_province_name`,
      SubdistrictId: `${addrPrefix}_subdistrict_id`,
      SubdistrictName: `${addrPrefix}_subdistrict_name`,
      VillageId: `${addrPrefix}_village_id`,
      VillageName: `${addrPrefix}_village_name`,
      Zipcode: `${addrPrefix}_zipcode`,
    } as const;

    setValue(keys.CityId, null);
    setValue(keys.CityName, null);
    setValue(keys.CountryId, null);
    setValue(keys.CountryName, null);
    setValue(keys.SubdistrictId, null);
    setValue(keys.SubdistrictName, null);
    setValue(keys.ProvinceId, null);
    setValue(keys.ProvinceName, null);
    setValue(keys.VillageId, null);
    setValue(keys.VillageName, null);
    setValue(keys.Zipcode, null);
    setValue(keys.LongLat, '0,0');
  };

  const onSelectContact = (type: 'shipper' | 'consignee', contact: IContact) => {
    // This whole thing is a way to add prefix
    // for contact fields based on `type`.
    const addrPrefix = type === 'shipper' ? 'shipper_pickup' : 'consignee_delivery';
    const keys = {
      ContactId: `${type}_contact_id`,
      Email: `${type}_email`,
      Name: `${type}_name`,
      PhoneNumber: `${type}_phone_number`,
      Address: `${addrPrefix}_address`,
      CityId: `${addrPrefix}_city_id`,
      CityName: `${addrPrefix}_city_name`,
      CountryId: `${addrPrefix}_country_id`,
      CountryName: `${addrPrefix}_country_name`,
      LongLat: `${addrPrefix}_longlat`,
      ProvinceId: `${addrPrefix}_province_id`,
      ProvinceName: `${addrPrefix}_province_name`,
      SubdistrictId: `${addrPrefix}_subdistrict_id`,
      SubdistrictName: `${addrPrefix}_subdistrict_name`,
      VillageId: `${addrPrefix}_village_id`,
      VillageName: `${addrPrefix}_village_name`,
      Zipcode: `${addrPrefix}_zipcode`,
    } as const;

    setValue(keys.ContactId, contact.contact_id);
    setValue(keys.Email, contact.email);
    setValue(keys.Name, contact.contact_name);
    setValue(keys.PhoneNumber, contact.phone_number);
    setValue(keys.Address, contact.address_street);

    if ((type === 'shipper' && (contact.address_city_id != origin_id))) {
      onResetAddress(type);
      return;
    }
    if ((type === 'consignee' && (contact.address_subdistrict_id != destination_id))) {
      onResetAddress(type);
      return;
    }
    setValue(keys.CityId, contact.address_city_id);
    setValue(keys.CityName, contact.address_city_name);
    setValue(keys.CountryId, contact.address_country_id);
    setValue(keys.CountryName, contact.address_country_name);
    setValue(keys.SubdistrictId, contact.address_subdistrict_id);
    setValue(keys.SubdistrictName, contact.address_subdistrict_name);
    setValue(keys.ProvinceId, contact.address_province_id);
    setValue(keys.ProvinceName, contact.address_province_name);
    setValue(keys.VillageId, contact.address_village_id);
    setValue(keys.VillageName, contact.address_village_name);
    setValue(keys.Zipcode, contact.address_zipcode);
    setValue(keys.LongLat, '0,0');
  };

  const handleOpenModalSelectContact = (type: 'shipper' | 'consignee') => (
    () => {
      modal.open({
        title: 'Pilih kontak',
        footer: false,
        template: (
          <SelectContactForm
            onSelectContact={(item) => {
              onSelectContact(type, item);
              modal.close();
            }}
            onCancel={modal.close}
          />
        ),
      });
    }
  );

  const handleOpenModalPackageForm = () => {
    modal.open({
      title: 'Tambah Paket',
      footer: false,
      width: 720,
      template: (
        <>
          <ParcelForm
            originId={getValues('origin_id')}
            destinationId={getValues('destination_id')}
            onCancel={modal.close}
            availableService={availableServices}
            onAddPackage={(pack) => {
              onAddPackage(pack);
              modal.close();
            }}
          />
        </>
      ),
    });
  };

  const handleCalculateSummary = async (payload: CalculateParcelPricePayload) => {
    try {
      const res = await calculateParcelPrice(payload);
      return res?.data?.data;
    } catch (error) {
      show('Harga untuk rute ini tidak tersedia', 'error');
    }
  };

  const syncCalculatePrice = async () => {
    const {
      origin_id,
      destination_id,
      product_service_code,
      is_insurance,
    } = getValues();
    const newParcel = await Promise.all(packages.map(async (pckg) => {
      try {
        const calculateRes: CalculateParcelPriceResponse = await handleCalculateSummary({
          customer_id: userLoginData.tenantId,
          destination_id,
          is_insurance,
          origin_id,
          parcel_value: +pckg.parcel_value,
          weight: +pckg.parcel_weight,
          product_service_code,
        });

        return {
          ...pckg,
          parcel_value: +calculateRes.parcel_value,
          parcel_weight: +calculateRes.weight,
          insurance_fee: calculateRes.insurance_fee,
          is_insurance: calculateRes.is_insurance,
          discount_amount: calculateRes.shipping_price_unit_discount_amount,
          shipping_price: calculateRes.shipping_price_unit_before_discount * calculateRes.weight,
          price: calculateRes.shipping_price_unit_before_discount,
          price_subtotal: calculateRes.total_shipping_price_before_discount,
          total_price: calculateRes.total_price,
          route_id: calculateRes.route_id,
          pricelist_id: calculateRes.pricelist_id,
        };
      } catch (error) {
        show('Harga untuk rute ini tidak tersedia', 'error');
        return pckg;
      }
    }));

    setPackages(newParcel);
    syncTotalParcel(newParcel);
  };

  const syncTotalParcel = (parcels: Package[]) => {
    if (parcels.length === 0) return;

    const totalInsuranceFee = Number(parcels.reduce((acc, { insurance_fee }) => acc + insurance_fee, 0));
    const totalDiscountAmount = Number(parcels.reduce((acc, { discount_amount }) => acc + discount_amount, 0));
    const totalDiscountPerc = Number(parcels.reduce((acc, { discount_perc = 0 }) => acc + discount_perc, 0));
    const totalShippingPrice = Number(parcels.reduce((acc, { shipping_price }) => acc + shipping_price, 0));
    const totalPrice = Number(parcels.reduce((acc, { total_price }) => acc + total_price, 0));

    setValue('insurance_fee', totalInsuranceFee);
    setValue('discount_amount', totalDiscountAmount);
    setValue('discount_perc', totalDiscountPerc);
    setValue('shipping_price', totalShippingPrice);
    setValue('total_price', totalPrice);
  };

  function handleOnSubmit() {
    const payload: IOrderCreatePayload = {
      ...(getValues() as IOrderCreatePayload),
      package: packages,
      is_shipper_create_to_contact: selectedTypeContact === 'create-contact',
      is_consignee_create_to_contact: selectedTypeConsignee === 'create-contact',
      pickup_schedule_date_time_utc: isArray(getValues('pickup_schedule_date_time_utc')) ? getValues('pickup_schedule_date_time_utc')[0] : getValues('pickup_schedule_date_time_utc'),
    };

    props.onSubmit(payload);
  }

  const handleCheckShippingPrice = async (values: any) => {
    setAvailableService([]);
    try {
      const res = await checkShippingPrice({
        customer_id: userLoginData.tenantId,
        ...values,
      });

      const data: [] = res?.data?.data || [];

      if (data) {
        setAvailableService(data);
      }
    } catch (error) {
      show('Rute asal dan tujuan tidak tersedia', 'error');
    }
  };

  useEffect(() => {
    if (packages.length > 0) {
      syncCalculatePrice();
    }
  }, [origin_id, destination_id, getValues('product_service_code'), getValues('is_insurance')]);

  useEffect(() => {
    if (origin_id && destination_id) {
      const payload = {
        destination_id,
        origin_id,
      };
      handleCheckShippingPrice(payload);
    }
  }, [origin_id, destination_id]);

  return (
    <BaseForm
      onFinish={handleOnSubmit}
      customForm={form}
    >
      <>
        <div className="flex gap-x-12 items-center mb-8">
          <div className="w-[500px]">
            <FormField
              component="form"
              name="order_number"
              label="Order Number"
              componentProps={{
                label: 'Order Number',
              }}
            />
          </div>
          <div className="w-[500px]">
          </div>
        </div>
        <div className="flex gap-x-12 items-center mb-8">
          <div className="w-[500px]">
            <FormField
              component="datepicker"
              name="order_date_time_utc"
              label="Tanggal Order"
              componentProps={{
                label: 'Tanggal Order',
                variant: 'default',
                required: true,
              }}
            />
          </div>
          <div className="w-[500px]">
            <FormField
              component="queryfield"
              name="branch"
              label="Cabang"
              componentProps={{
                label: 'Nama Cabang',
                endpoint: 'branches',
                keyOptionLabel: 'branch_name',
                keyOptionValue: 'branch_id',
                keyQueryFilter: 'branch_name',
                queryFilter: { is_active: true },
                required: true,
                onSelected: (record: any) => {
                  setValue('branch_id', record.value);
                  setValue('branch_name', record.value);
                },
              }}
            />
          </div>
        </div>
        <div className="flex gap-x-12 items-center mb-8">
          <div className="w-[500px]">
            <FormField
              component="queryfield"
              name="origin"
              label="Asal"
              componentProps={{
                label: 'Asal',
                endpoint: 'cities',
                dataProviderName: 'masterdata',
                keyQueryFilter: 'city_name',
                keyOptionLabel: 'city_name',
                keyOptionValue: 'city_id',
                required: true,
                onSelected: (record: any) => {
                  setValue('origin_id', record.value);
                  setValue('origin_name', record.label);
                  setValue('origin_timezone_id', record?.record?.timezone_id || 'Asia/Jakarta|WIB');
                  setValue('origin_timezone_offset', record?.record?.timezone_offset || 420);
                  if (record.value != getValues('shipper_pickup_city_id')) {
                    onResetAddress('shipper');
                  }
                },
              }}
            />
          </div>
          <div className="w-[500px]">
            <FormField
              component="queryfield"
              name="destination"
              label="Tujuan"
              componentProps={{
                label: 'Tujuan',
                endpoint: 'destinations',
                dataProviderName: 'masterdata',
                keyOptionValue: 'destination_id',
                keyOptionLabel: 'destination_name',
                keyQueryFilter: 'destination_name',
                onSelectedOutputKey: 'record',
                required: true,
                onSelected: (record: any) => {
                  setValue('destination_id', record.value);
                  setValue('destination_name', record.label);
                  setValue('destination_timezone_id', record?.record?.timezone_id);
                  setValue('destination_timezone_offset', record?.record?.timezone_offset);
                  if (record.value !== getValues('consignee_delivery_subdistrict_id')) {
                    onResetAddress('consignee');
                  }
                },
              }}
            />
          </div>
        </div>
        <div className="grid grid-flow-col grid-col-2 gap-x-8 mb-8">
          <div className="px-4 py-4 bg-white border border-zinc-200 rounded-md">
            <div className="mb-4">
              <Typography level={5} fontWeight="bold">Pengirim</Typography>
            </div>
            <div className="text-right">
              <div className="inline-flex border rounded-lg mb-5">
                <label className={`py-2 px-2 cursor-pointer border rounded-l-lg text-sm ${selectedTypeContact === 'select-contact' ? 'bg-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
                  <input
                    type="radio"
                    value="select-contact"
                    checked={selectedTypeContact === 'select-contact'}
                    className="hidden"
                    onChange={() => {
                      setSelectedTypeContact('select-contact');
                    }}
                  />
                  Pilih Kontak
                </label>
                <label className={`py-2 px-2 cursor-pointer border rounded-r-lg text-sm ${selectedTypeContact === 'create-contact' ? 'bg-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
                  <input
                    type="radio"
                    value="create-contact"
                    checked={selectedTypeContact === 'create-contact'}
                    className="hidden"
                    onChange={() => {
                      setSelectedTypeContact('create-contact');
                      setValue('shipper_name', null);
                      setValue('shipper_phone_number', null);
                      setValue('shipper_pickup_address', '');
                      onResetAddress('shipper');
                    }}
                  />
                  Buat Baru
                </label>
              </div>
            </div>
            <div className="flex flex-col gap-y-4 mb-4">
              <div className="flex justify-between gap-3">
                <FormField
                  component="form"
                  name="shipper_name"
                  label="Nama"
                  className="flex-auto"
                  componentProps={{
                    disabled: !origin_id,
                    label: 'Nama',
                    required: true,
                  }}
                />
                <Button
                  type="button"
                  onClick={handleOpenModalSelectContact('shipper')}
                  disabled={!origin_id || selectedTypeContact === 'create-contact'}
                >
                  <ContactIcon />
                </Button>
              </div>
              <FormField
                component="form"
                name="shipper_phone_number"
                label="No Telp"
                componentProps={{
                  disabled: !origin_id,
                  label: 'No Telp',
                  required: true,
                }}
              />
              <FormField
                key={`${shipper_pickup_city_id}-${origin_id}` || '0'}
                id="shipper_pickup_subdistrict"
                component="queryfield"
                name="shipper_pickup_subdistrict_name"
                label="Kecamatan / Kota"
                componentProps={{
                  disabled: !origin_id,
                  label: 'Kecamatan / Kota',
                  endpoint: 'subdistricts',
                  required: true,
                  keyOptionValue: 'subdistrict_id',
                  keyQueryFilter: 'subdistrict_name',
                  keyOptionLabel: (record) => `${record?.subdistrict_name}, ${record?.city_name}, ${record?.province_name}, ${record?.country_name}`,
                  dataProviderName: 'masterdata',
                  queryFilter: {
                    city_id: origin_id,
                  },
                  onSelected: (record: any) => {
                    setValue('shipper_pickup_subdistrict_id', record.value);
                    setValue('shipper_pickup_subdistrict_name', record?.record?.subdistrict_name);
                    setValue('shipper_pickup_city_name', record?.record?.city_name);
                    setValue('shipper_pickup_city_id', record?.record?.city_id);
                    setValue('shipper_pickup_province_name', record?.record?.province_name);
                    setValue('shipper_pickup_province_id', record?.record?.province_id);
                    setValue('shipper_pickup_country_name', record?.record?.country_name);
                    setValue('shipper_pickup_country_id', record?.record?.country_id);

                    setValue('shipper_pickup_village_id', null);
                    setValue('shipper_pickup_village_name', null);
                    setValue('shipper_pickup_zipcode', null);
                  },
                }}
              />
              <FormField
                key={shipper_pickup_village_id || '1'}
                id="shipper_pickup_village"
                component="queryfield"
                name="shipper_pickup_village_id"
                label="Kelurahan / Kode Pos"
                componentProps={{
                  disabled: !origin_id || !getValues('shipper_pickup_subdistrict_id'),
                  label: 'Kelurahan / Kode Pos',
                  endpoint: 'villages',
                  required: true,
                  keyOptionValue: 'village_id',
                  keyQueryFilter: 'subdistrict_name',
                  queryFilter: {
                    subdistrict_id: getValues('shipper_pickup_subdistrict_id'),
                  },
                  keyOptionLabel: (record) => `${record?.village_name} - ${record?.zipcode}`,
                  dataProviderName: 'masterdata',
                  onSelected: (record: any) => {
                    setValue('shipper_pickup_village_id', record.value);
                    setValue('shipper_pickup_village_name', record?.record?.village_name);
                    setValue('shipper_pickup_zipcode', record.record?.zipcode);
                  },
                }}
              />

              <div className="flex items-center flex-row">
                <div className="text-sm text-wrap w-32">
                  Alamat Pickup
                  <span className="ml-1 text-red-500">*</span>
                </div>
                <div className="flex-auto">
                  <TextArea
                    rows={4}
                    name="shipper_pickup_address"
                    label="Alamat Pickup"
                    value={watch('shipper_pickup_address')}
                    onChange={(e) => {
                      setValue('shipper_pickup_address', e.target.value);
                    }}
                    required
                    disabled={!origin_id}
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <FormField
                  name="is_save_shipper_data"
                  component="checkbox"
                  componentProps={{
                    disabled: !origin_id,
                    defaultChecked: true,
                    label: `${selectedTypeContact === 'create-contact' ? 'Simpan ke Kontak' : 'Simpan Perubahan'}`,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="px-4 py-4 bg-white border border-zinc-200 rounded-md">
            <div className="mb-4">
              <Typography level={5} fontWeight="bold">Penerima</Typography>
            </div>
            <div className="text-right">
              <div className="inline-flex border rounded-lg mb-5">
                <label className={`py-2 px-2 cursor-pointer border rounded-l-lg text-sm ${selectedTypeConsignee === 'select-contact' ? 'bg-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
                  <input
                    type="radio"
                    value="select-contact"
                    checked={selectedTypeConsignee === 'select-contact'}
                    className="hidden"
                    onChange={() => {
                      setSelectedTypeConsignee('select-contact');
                    }}
                  />
                  Pilih Kontak
                </label>
                <label className={`py-2 px-2 cursor-pointer border rounded-r-lg text-sm ${selectedTypeConsignee === 'create-contact' ? 'bg-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
                  <input
                    type="radio"
                    value="create-contact"
                    checked={selectedTypeConsignee === 'create-contact'}
                    className="hidden"
                    onChange={() => {
                      setSelectedTypeConsignee('create-contact');
                      setValue('consignee_name', null);
                      setValue('consignee_phone_number', null);
                      setValue('consignee_delivery_address', '');
                      onResetAddress('consignee');
                    }}
                  />
                  Buat Baru
                </label>
              </div>
            </div>
            <div className="flex flex-col gap-y-4 mb-4">
              <div className="flex justify-between gap-3">
                <FormField
                  component="form"
                  name="consignee_name"
                  label="Nama"
                  className="flex-auto"
                  componentProps={{
                    disabled: !destination_id,
                    label: 'Nama',
                    required: true,
                  }}
                />
                <Button
                  type="button"
                  onClick={handleOpenModalSelectContact('consignee')}
                  disabled={!destination_id || selectedTypeConsignee === 'create-contact'}
                >
                  <ContactIcon />
                </Button>
              </div>
              <FormField
                component="form"
                name="consignee_phone_number" // TODO
                label="No Telp"
                componentProps={{
                  disabled: !destination_id,
                  label: 'No Telp',
                  required: true,
                }}
              />
              <FormField
                key={consignee_delivery_subdistrict_id || '2'}
                id="consignee_delivery_subdistrict"
                component="queryfield"
                name="consignee_delivery_subdistrict_name"
                label="Kecamatan / Kota"
                componentProps={{
                  disabled: !destination_id,
                  label: 'Kecamatan / Kota',
                  endpoint: 'subdistricts',
                  required: true,
                  keyOptionValue: 'subdistrict_id',
                  keyQueryFilter: 'subdistrict_name',
                  keyOptionLabel: (record) => `${record?.subdistrict_name}, ${record?.city_name}, ${record?.province_name}, ${record?.country_name}`,
                  dataProviderName: 'masterdata',
                  queryFilter: {
                    subdistrict_id: destination_id,
                  },
                  onSelected: (record: any) => {
                    setValue('consignee_delivery_subdistrict_id', record.value);
                    setValue('consignee_delivery_subdistrict_name', record?.record?.subdistrict_name);
                    setValue('consignee_delivery_city_name', record?.record?.city_name);
                    setValue('consignee_delivery_city_id', record?.record?.city_id);
                    setValue('consignee_delivery_province_name', record?.record?.province_name);
                    setValue('consignee_delivery_province_id', record?.record?.province_id);
                    setValue('consignee_delivery_country_name', record?.record?.country_name);
                    setValue('consignee_delivery_country_id', record?.record?.country_id);

                    setValue('consignee_delivery_village_id', null);
                    setValue('consignee_delivery_village_name', null);
                    setValue('consignee_delivery_zipcode', null);
                  },
                }}
              />
              <FormField
                key={consignee_delivery_village_id || '3'}
                id="consignee_delivery_village_id"
                component="queryfield"
                name="consignee_delivery_village_id"
                label="Kelurahan / Kode Pos"
                componentProps={{
                  disabled: !destination_id || !getValues('consignee_delivery_subdistrict_id'),
                  label: 'Kelurahan / Kode Pos',
                  endpoint: 'villages',
                  required: true,
                  keyOptionValue: 'village_id',
                  keyQueryFilter: 'subdistrict_name',
                  queryFilter: {
                    subdistrict_id: getValues('consignee_delivery_subdistrict_id'),
                  },
                  keyOptionLabel: (record) => `${record?.village_name} - ${record?.zipcode}`,
                  dataProviderName: 'masterdata',
                  onSelected: (record: any) => {
                    setValue('consignee_delivery_village_id', record.value);
                    setValue('consignee_delivery_village_name', record.record?.village_name);
                    setValue('consignee_delivery_zipcode', record.record?.zipcode);
                  },
                }}
              />
              <div className="flex items-center flex-row">
                <div className="text-sm text-wrap w-32">
                  Alamat Pengiriman
                  <span className="ml-1 text-red-500">*</span>
                </div>
                <div className="flex-auto">
                  <TextArea
                    rows={4}
                    name="consignee_delivery_address"
                    label="Alamat Pengiriman"
                    value={watch('consignee_delivery_address')}
                    onChange={(e) => {
                      setValue('consignee_delivery_address', e.target.value);
                    }}
                    required
                    disabled={!destination_id}
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <FormField
                  name="is_save_consignee_data"
                  component="checkbox"
                  componentProps={{
                    disabled: !destination_id,
                    label: `${selectedTypeConsignee === 'create-contact' ? 'Simpan ke Kontak' : 'Simpan Perubahan'}`,
                    defaultChecked: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-x-12 mb-8">
          <div className="flex flex-col gap-y-8">
            {/* Ga tau kenapa radiogroup dari FormField ngga work. */}
            <div className={'flex items-center flex-row'}>
              <div className="text-sm text-wrap w-32">
                {'Metode'}
                <span className="ml-1 text-red-500">*</span>
              </div>
              <div className="flex-auto">
                <RadioGroup
                  onChange={(e) => {
                    setValue('order_method', e.target.value);
                    setCurrentOrderMethod(e.target.value);
                  }}
                  value={getValues('order_method')}
                >
                  <Radio
                    className="cursor-pointer"
                    id="order_method_pick"
                    label="Pickup"
                    value="pickup"
                    name="pick"
                  />
                  <Radio
                    className="cursor-pointer"
                    id="order_method_drop"
                    label="Drop"
                    value="drop"
                    name="drop"
                  />
                </RadioGroup>
              </div>
            </div>
            {currentOrderMethod === 'pickup' && (
              <FormField
                component="datepicker"
                name="pickup_schedule_date_time_utc" // TODO
                label="Tanggal Pickup"
                componentProps={{
                  variant: 'withTime',
                }}
              />
            )}
          </div>
          <div className="">
            <FormField
              component="textarea"
              name="courier_note"
              label="Catatan Untuk Kurir&nbsp;"
              className="!items-start"
              componentProps={{
                name: 'courier_note',
                rows: 5,
              }}
            />
          </div>
        </div>
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <Typography level={4} fontWeight="bold">Daftar Paket</Typography>
            <Button
              variant="tertiary"
              type="button"
              onClick={() => handleOpenModalPackageForm()}
              disabled={!(getValues('origin_id') && getValues('destination_id'))}
            >
              Tambah Paket
            </Button>
          </div>
          <ParcelTable
            data={packages || []}
            onRemove={onRemoveParcel}
            availableService={availableServices}
            onUpdate={(record, index) => {
              modal.open({
                title: 'Edit Paket',
                footer: false,
                width: 720,
                template: (
                  <>
                    <ParcelForm
                      originId={getValues('origin_id')}
                      destinationId={getValues('destination_id')}
                      onCancel={modal.close}
                      availableService={availableServices}
                      record={record}
                      onAddPackage={(pack) => {
                        if (index !== null) {
                          const newPackageItem = packages?.map((item, i) => {
                            if (i === index) {
                              return {
                                ...pack,
                              };
                            }
                            return item;
                          })
                          syncTotalParcel(newPackageItem);
                          setPackages(newPackageItem);
                          modal?.close();
                        }
                      }}
                    />
                  </>
                ),
              });
            }}
          />
        </div>
        {packages && packages?.length > 0 && (
          <div className="mb-8 font-semibold">
            <div className="flex items-center justify-end mb-4 gap-4">
              <div>Total Ongkir</div>
              <div className="w-[150px] text-right">{convertNumberToCurrency(getValues('shipping_price') || 0)}</div>
            </div>
            <div className="flex items-center justify-end mb-4 gap-4">
              <div>Total Biaya Asuransi</div>
              <div className="w-[150px] text-right">{convertNumberToCurrency(getValues('insurance_fee') || 0)}</div>
            </div>
            <div className="flex items-center justify-end mb-4 gap-4">
              <div>Diskon</div>
              <div className="w-[150px] text-right">{convertNumberToCurrency(getValues('discount_amount') || 0)}</div>
            </div>
            <div className="flex items-center justify-end mb-4 gap-4">
              <div>Total</div>
              <div className="w-[150px] text-right">{convertNumberToCurrency(getValues('total_price') || 0)}</div>
            </div>
          </div>
        )}
      </>
    </BaseForm>
  );
}

export default OrderForm;
